import * as React from 'react'

const Radio = ({
  checked,
  disabled,
  onClick,
  onChange,
}: {
  onClick?: () => void
  checked: boolean
  disabled?: boolean
  onChange?: (checked: boolean) => void
}) => {
  return (
    <input
      disabled={disabled}
      type="radio"
      onClick={(e) => {
        e.stopPropagation()
        onClick?.()
      }}
      checked={checked}
      onChange={(e) => onChange?.(!!e)}
      onMouseDown={(e) => e.stopPropagation()}
      className={`appearance-none tw-h-4 tw-w-4 tw-rounded-full tw-border tw-border-gray-400 ${checked ? '!tw-border-red-500 !tw-bg-red-200' : '!tw-bg-white'} ${disabled ? 'tw-cursor-not-allowed tw-border-neutral/30 tw-bg-base-300' : 'tw-cursor-pointer'} `}
    />
  )
}

export default Radio
